// extracted by mini-css-extract-plugin
export default {"Wrapper":"GroupAdd_Wrapper__BouXM","Container":"GroupAdd_Container__YJ5Hn"};